import 'css-chunksrc/client/scenes/moveElement/projectsSelection/styles.scss';export default {
  "projectsSelection": "_projectsSelection_zc06f_1",
  "root": "_root_zc06f_12",
  "search": "_search_zc06f_18",
  "list": "_list_zc06f_22"
};